<template>
  <!-- Org-scoped home (recent workflows + projects for the current org) -->
  <org-dashboard v-if="hydrated && hasOrgs" />

  <!-- No orgs yet: the onboarding / create-first-org view -->
  <dashboard-start v-else-if="hydrated" />

  <!-- Resolving the current org -->
  <div v-else>
    <navigation-top />
    <div class="d-flex justify-center pa-12">
      <v-progress-circular indeterminate color="primary" />
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import OrgDashboard from './OrgDashboard.vue'
import DashboardStart from './DashboardStart.vue'
import NavigationTop from '@/components/NavigationTop.vue'

const store = useStore()

const hydrated = computed(() => store.state.currentOrg.hydrated)
const hasOrgs = computed(() => store.getters['currentOrg/orgs'].length > 0)

onMounted(() => {
  if (!store.state.currentOrg.hydrated) {
    store.dispatch('currentOrg/hydrate')
  }
})
</script>
